import { useTranslation } from "react-i18next";
import connectedIcon from "src/assets/svgs/tacho-card-connected.svg?url";
import disconnectedIcon from "src/assets/svgs/tacho-card-disconnected.svg?url";
import type { TachographCardRecord } from "src/services/tachographCardService";

const TachographCardConnectionCell = ({
  hardwareStatus,
}: Pick<TachographCardRecord, "hardwareStatus">) => {
  const { t } = useTranslation();

  if (hardwareStatus == null) {
    return <span>--</span>;
  }

  const isConnected = hardwareStatus === 1;

  return (
    <span className="inline-flex items-center gap-2 whitespace-nowrap text-[14px] font-normal leading-[18px] text-[#000000]">
      <img src={isConnected ? connectedIcon : disconnectedIcon} alt="" className="shrink-0" />
      {t(isConnected ? "connected" : "disconnected")}
    </span>
  );
};

export default TachographCardConnectionCell;
